import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/AppShell";
import { Regolamento } from "../components/Regolamento";
import { LegalFooter } from "../components/LegalFooter";

export default function RulesPage() {
  return (
    <div className="min-h-screen pitch-bg">
      <header className="border-b border-[#26334D]">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <Logo />
          <Link to="/" className="flex items-center gap-2 text-sm text-slate-400 hover:text-white" data-testid="rules-back-link">
            <ArrowLeft size={16} /> Torna al sito
          </Link>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-10 sm:py-14">
        <Regolamento />
      </main>
      <LegalFooter />
    </div>
  );
}
